module.exports = __webpack_public_path__ + "static/img/ngdc-nav.698c6c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ngdc-nav.png
// module id = vr/F
// module chunks = 1